module.exports = __webpack_public_path__ + "img/follow_bg_desc.71eb3f2f.png";